import { createFileRoute } from '@tanstack/react-router'

import { OpportunityDetail } from '@/components/opportunities/opportunity-detail'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/opportunities/$opportunityId')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: OpportunityDetailPage,
})

function OpportunityDetailPage() {
  const { opportunityId } = Route.useParams()
  return <OpportunityDetail opportunityId={opportunityId} />
}
